export default "__VITE_PUBLIC_ASSET__0532d1a7__"